const upDown = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m8.05 0 4.56 4.55H8.78v6.905h3.83l-4.56 4.55-4.55-4.55h3.72V4.55H3.5z"/></svg>',
};

export { upDown as default };
